

<div>

    <label i18n="@@jraapASAF" class="textColour">Are you sure you want to rerun this report ?</label>

</div>

<div style="margin-top: 25px;">
    <div style=" margin-bottom: 10px;">
        <label>
          <input type="radio" name="datasetOption" value="existing" [(ngModel)]="selectedOption" (ngModelChange)="optionChanged()">
          Existing Dataset
        </label>
        <label  class="radio-gap">
          <input type="radio" name="datasetOption" value="recreate" [(ngModel)]="selectedOption" (ngModelChange)="optionChanged()">
          Refresh the report dataset
        </label>
      </div>
      
    <div class="col-lg">
        <div class="container" style="text-align: center;">
          <div class="row topRowMargins">

            <div class="col-lg">

              <div style="text-align: end">

                <button i18n="@@TMRunButton" type="button" (click)="save()" [style.background-color]="backgroundColorButton"
                class="btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" style="padding: .3rem 1.6rem;" [style.background-color]="backgroundColorButton">Rerun</button>

                <button i18n="@@TMRunButton" type="button" (click)="cancel()" [style.background-color]="backgroundColorButton"
                class="cancelButton btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" style="padding: .3rem 1.6rem;" [style.border-color]="backgroundColorButton">Cancel</button>

              </div>

            </div>

          </div>
        </div>
      </div>
</div>

